import { requestLogin } from "@/api/login";
import {
  setToken,
  removeToken,
  setSecret,
  removeSecret,
  setName,
  removeName
} from "@/utils/auth";

const user = {
  state: {
    userName: "",
    stage: 0,
    loginStage: "", // 登陆后获取的状态值保存
    linkSource: "" // 地址栏的source，用来记录是从哪里来的数据
  },

  mutations: {
    setUserName: (state, name) => {
      state.userName = name;
    },
    setStage(state, value) {
      state.stage = value;
    },
    setLoginStage(state, value) {
      state.loginStage = value;
    },
    setLinkSource(state, value) {
      state.linkSource = value;
    }
  },

  actions: {
    // 登录
    Login({ commit }, loginForm) {
      return new Promise((resolve, reject) => {
        requestLogin({
          mobile: loginForm.userName,
          pwd: loginForm.pwd
        }).then(res => {
          if (res.data.result === "01") {
            setToken(res.data.data["ticketid"]);
            setSecret(res.data.data["login-secret-key"]);
            setName(res.data.data["user_name"]);
            commit("setUserName", res.data.data["user_name"]);
            resolve(1);
          } else {
            reject(res.data.msg || res.data.message);
          }
        });
      });
    },

    // 保存申请状态
    saveStage({ commit }, value) {
      commit("setStage", value);
    },

    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        removeToken();
        removeSecret();
        removeName();
        commit("setUserName", "");
        resolve("退出成功！");
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js